<div
  class="app-sign-field-item pl3 pr1 py1 flex items-center justify-between"
  [class.app-sign-field-item--active]="active"
>
  <div class="pl2 font-small flex items-center mr2">
    <div class="mr1">{{ name }}</div>
    <lib-icon
      [icon]="signField.type | signatureTypeIcon"
      [inline]="true"
      class="mr1 font-medium"
    ></lib-icon>
  </div>

  <div class="flex items-center">
    <mat-form-field
      *ngIf="showSignFieldPriority"
      class="app-sign-field-list-item-priority flex-grow-1 mr1"
      appearance="outline"
    >
      <input
        matInput
        type="number"
        [value]="signFieldPriority"
        (change)="onChangeSignFieldPriority($event)"
      />
    </mat-form-field>

    <lib-button
      onlyIcon="edit"
      weight="tertiary"
      [small]="true"
      [matTooltip]="'SIGN_FIELD_LIST_ITEM.CHANGE_SIGNATUTE_TYPE' | translate"
      [matMenuTriggerFor]="sigTypeSelect"
    ></lib-button>

    <mat-menu #sigTypeSelect="matMenu">
      <button mat-menu-item (click)="onChangeSignFieldType(signField, SignatureType.Hand)">
        <div class="flex items-center" [class.bold]="signField.type === SignatureType.Hand">
          <lib-icon icon="edit" class="mr1"></lib-icon>{{ 'SIGNATURE.TITLE' | translate }}
        </div>
      </button>
      <button mat-menu-item (click)="onChangeSignFieldType(signField, SignatureType.Email)">
        <div class="flex items-center" [class.bold]="signField.type === SignatureType.Email">
          <lib-icon icon="mail_outline" class="mr1"></lib-icon
          >{{ 'SIGNATURE.VERIFY_CODE.EMAIL' | translate }}
        </div>
      </button>
      <button mat-menu-item (click)="onChangeSignFieldType(signField, SignatureType.SMS)">
        <div class="flex items-center" [class.bold]="signField.type === SignatureType.SMS">
          <lib-icon icon="sms" class="mr1"></lib-icon>{{ 'SIGNATURE.VERIFY_CODE.SMS' | translate }}
        </div>
      </button>
    </mat-menu>

    <lib-button
      [onlyIcon]="'delete'"
      weight="tertiary"
      [small]="true"
      (click)="deleteSignField.emit(signField)"
    ></lib-button>
  </div>
</div>
